import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { getAppConfigPath, getTeamDataPath } from '../utils/paths';
import firebaseApp from '../firebase-app';
import { AppConfigData } from '../types/app-config';
import { doc, onSnapshot } from 'firebase/firestore';
import { TeamData } from '../types/team';

type Config = {
  appConfig: AppConfigData;
  teamConfig: TeamData;
  setSelectedAbbrv: (abbrv: string) => void;
  selectedAbbrv: string;
};

export const ConfigContext = createContext<Config>({} as Config);

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const [selectedAbbrv, setSelectedAbbrv] = useState<string>('');
  const [appConfig, setAppConfig] = useState<AppConfigData | null>(null);
  const [teamConfig, setTeamConfig] = useState<TeamData | null>(null);

  useEffect(() => {
    if (selectedAbbrv) {
      const appConfigDoc = doc(firebaseApp.db, getAppConfigPath(selectedAbbrv));
      const unsubscribe = onSnapshot(appConfigDoc, (doc) => {
        setAppConfig(doc.data() as AppConfigData);
      });

      return () => {
        unsubscribe();
      };
    }
  }, [selectedAbbrv]);

  useEffect(() => {
    if (selectedAbbrv) {
      const teamConfigDoc = doc(firebaseApp.db, getTeamDataPath(selectedAbbrv));
      const unsubscribe = onSnapshot(teamConfigDoc, (doc) => {
        setTeamConfig(doc.data() as TeamData);
      });

      return () => {
        unsubscribe();
      };
    }
  }, [selectedAbbrv]);

  return (
    <ConfigContext.Provider
      value={{
        setSelectedAbbrv,
        selectedAbbrv: selectedAbbrv as string,
        appConfig: appConfig || ({} as AppConfigData),
        teamConfig: teamConfig || ({} as TeamData),
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigContext;
